<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">订单号：</span>
					<el-input v-model="search_number" class="b_inp" placeholder="订单号"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">商品名称：</span>
					<el-input v-model="search_goods" class="b_inp" placeholder="商品名称"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">购买账户：</span>
					<el-input v-model="search_uCode" class="b_inp" placeholder="商户账号"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker v-model="search_startDate" :editable="false" placeholder="开始时间" type="date"
						value-format="yyyy-MM-dd" @change="handleSearchDateChange">
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker v-model="search_endDate" :editable="false" placeholder="结束时间" type="date"
						value-format="yyyy-MM-dd" @change="handleSearchDateChange">
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">支付类型：</span>
					<el-select v-model="search_payType" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in appPayType" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="b_item">
					<span class="b_label">订单状态：</span>
					<el-select v-model="search_orderStatus" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option v-for="v in appOrderStatus" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="b_item">
					<span class="b_label">流水号：</span>
					<el-input v-model="search_serial" class="b_inp" placeholder="流水号"></el-input>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->

			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="number" label="订单号">
					</el-table-column>
					<el-table-column prop="goodsName" label="商品名称">
					</el-table-column>
					<el-table-column prop="price" label="价格">
					</el-table-column>
					<el-table-column prop="num" label="数量">
					</el-table-column>
					<el-table-column prop="amount" label="支付总额">
					</el-table-column>
					<el-table-column prop="receiverName" label="收货人">
					</el-table-column>
					<el-table-column prop="receiverPhone" label="收货人手机号">
					</el-table-column>
					<el-table-column width="300" prop="addr" label="收货地址">
					</el-table-column>
					<el-table-column prop="serial" label="流水号">
					</el-table-column>
					<el-table-column prop="shopName" label="店铺名称">
					</el-table-column>
					<el-table-column prop="uCode" label="购买账户">
					</el-table-column>
					<el-table-column prop="payTypeLabel" label="支付类型">
					</el-table-column>
					<el-table-column prop="time" label="下单时间">
					</el-table-column>
					<el-table-column prop="sendLabel" label="发货状态">
					</el-table-column>
					<el-table-column prop="orderStatusLabel" label="订单状态">
					</el-table-column>
					<el-table-column label="操作" width="300">
						<template slot-scope="scope">
							<el-button @click="handleViewClick(scope.row)">查看</el-button>
							<el-button @click="handleUpdateClick(scope.row)">修改</el-button>
							<el-button @click="handleSendClick(scope.row)">发货</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, prev, pager, next, jumper" next-text="下一页" :total="total"
						:current-page="currentPage" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>

		<!-- 查看 -->
		<view-popup v-model="view_display" :obj="view_data"></view-popup>
		<!-- 查看 end -->

		<!-- 修改 -->
		<update v-model="update_display" :obj="update_data" @onSuccess="updateSuccess"></update>
		<!-- 修改 end -->

		<!-- 发货 -->
		<send v-model="send_display" :orderId="send_id" @onSuccess="sendSuccess"></send>
		<!-- 发货 end -->
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import ViewPopup from './components/view.vue';
	import Update from './components/update.vue';
	import Send from './components/send.vue';
	import Api from '../../../../../../api/index.js';

	export default {
		mounted() {
			this.getData();
		},
		data() {
			return {
				loading: false,

				search_number: '',
				search_goods: '',
				search_uCode: '',
				search_startDate: '',
				search_endDate: '',
				search_payType: '',
				search_orderStatus: '',
				search_serial: '',

				total: 0,
				currentPage: 1,
				tableData: [],

				view_display: false,
				view_data: {},

				update_display: false,
				update_data: {},

				send_display: false,
				send_id: ''
			}
		},
		computed: {
			...mapState([
				'appManager',
				'appPayType',
				'appOrderStatus',
				'appSendStatus'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 切换时间
			handleSearchDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击查看
			handleViewClick(obj) {
				this.view_data = {
					...obj
				};
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(obj) {
				this.update_data = {
					...obj
				};
				this.update_display = true;
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 点击发货
			handleSendClick(obj) {
				this.send_id = obj.id;
				this.send_display = true;
			},
			// 发货成功
			sendSuccess() {
				this.getData();
			},

			/******************** @Function *************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageSize: 10,
					pageNum: that.currentPage,
					goodsName: that.search_goods,
					userPhone: that.search_uCode,
					orderNo: that.search_number,
					orderSerialNo: that.search_serial,
					orderPayType: that.search_payType,
					orderPayStatus: that.search_orderStatus,
					start: that.search_startDate,
					end: that.search_endDate,
					typeChannel: 2
				};
				Api.findOrderForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							let extraJson = v.goodsId == 10039 ? JSON.parse(v.extraJson) : {}
							list.push({
								id: v.orderId,
								number: v.orderNo,
								goodsId: v.goodsId,
								goodsName: v.goodsName,
								price: v.goodsMoneyYuan,
								num: v.num,
								amount: v.orderTotalMoneyYuan,
								addr: v.address,
								serial: v.orderSerialNo || '',
								shopName: v.shopName,
								uCode: v.userPhone,
								payTypeValue: v.orderPayType,
								payTypeLabel: that.mapPayTypeValueToLabel(v.orderPayType),
								time: v.createTs.split(' ')[0],
								sendValue: v.sendFlag,
								sendLabel: that.mapSendValueToLabel(v.sendFlag),
								orderStatusValue: v.orderPayStatus,
								orderStatusLabel: that.mapOrderStatusValueToLabel(v
									.orderPayStatus),
								level: v.levelName,
								specificationId: extraJson.specificationsId,
								specificationLabel: v.specificationsName,
								frameId: extraJson.spectaclesFrameId,
								valueAddedId: extraJson.valueAddedId, //增值服务
								frameLabel: v.spectaclesFrameName,
								valueAddedName: v.valueAddedName,
								refractionR: v.diopterRight,
								refractionL: v.diopterLeft,
								astigmatismR: v.astigmatismRight,
								astigmatismL: v.astigmatismLeft,
								axialR: v.axialRight,
								axialL: v.axialLeft,
								distance: v.pupillaryDistance,
								affirm: v.affirm,
								receiverName:v.receiverName,
								receiverPhone:v.receiverPhone
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			},
			// 把支付类型转为文字
			mapPayTypeValueToLabel(value) {
				let result = '';
				this.appPayType.forEach(v => {
					value == v.id && (result = v.name);
				});
				return result;
			},
			// 把发货状态转为文字
			mapSendValueToLabel(value) {
				let result = '';
				this.appSendStatus.forEach(v => {
					value == v.id && (result = v.name);
				});
				return result;
			},
			// 把订单状态转为文字
			mapOrderStatusValueToLabel(value) {
				let result = '';
				this.appOrderStatus.forEach(v => {
					value == v.id && (result = v.name);
				});
				return result;
			}
		},
		components: {
			ViewPopup,
			Update,
			Send
		}
	}
</script>

<style scoped>
</style>
